<template>
    <div class="switch-languages-dropdown">
        <a v-for="lang of languagesList" :key="lang" class="switch-language" :href="getSwitchLanguageURL(lang)">
            {{ getSwitchLanguagesText(lang) }}
        </a>
    </div>
</template>

<script>
import { getSwitchLanguageURL, getSwitchLanguageString } from '../util/switchLanguage';

export default {
    name: 'TheSwitchLanguageDropdown',
    props: {
        languagesList: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        return {
            getSwitchLanguageURL,
        };
    },
    methods: {
        getSwitchLanguagesText(lang) {
            const text = getSwitchLanguageString(lang);
            if (!text) {
                this.$metrics
                    .newChildActionPublisherForMethod('SwitchLanguage')
                    .publishCounterMonitor(`missingLabel.${lang}`, 1);
            }
            return text || `View this site in ${lang}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.switch-languages-dropdown {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 16px;
    background-color: white;
    min-width: 225px;
    padding-top: 10px;
    box-shadow: 0 4px 4px rgb(0 0 0 / 30%);
    border: 1px solid #d8d8d8;
    border-top: 0;
    z-index: 200;

    a {
        color: #333;
    }

    a:hover {
        text-decoration: none;
    }
}

.switch-language {
    border: 1px solid white;
    color: #333;
    font-size: 13px;
    line-height: 20px;
    padding: 5px 30px 5px 12px;
    text-decoration: none;

    &:focus,
    &:hover {
        background-color: #f9f9f9;
        border-color: #ebebeb #f9f9f9 #ebebeb #e47911;
    }
}
</style>
